import React from 'react'
import { Grid } from '@mui/material'
import {Link} from 'react-router-dom'
import FireIcon from '../../../../assets/img/file/fire-icon.png'
import {Category, Type} from '../../../../assets/svg'
import './item.scss'

const CourseItem = ({data , size}) => (
        <Grid item sm={4} md={size} lg={size} className="card">                        
            <div className="card-img">
                <img className='course-img' src={data.link_img} alt="" />
                { data.is_hot_topic ? <span className={`topic`} ><img src={FireIcon}  /> Hot Topics</span> : null }
            </div>

            <div className="detail">
                <div className="info">
                    <div className="category">
                        <span>
                            <img src={Category} alt="" />
                            <span>{data.tipe}</span>
                        </span>
                    </div>

                    <div className="type">
                        <span>
                            <img src={Type} alt="" />
                            <span>{data.program}</span>
                        </span>
                    </div>
                </div>

                <div className="body">
                    <h3 className="subtitle">{data.title}</h3>
                    <p className="content">{data.short_description}</p>
                </div>           
            </div>

            <Link to={`/courses?id=${data.id}&menu=${data.menu.indexOf('Dojo') > -1 ? 1 : 2}`} className="link">Program Detail</Link>
    </Grid>
)

export default CourseItem